import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export function MarketCard({ icon: Icon, title, description, cta, to }) {
  return (
    <Link
      to={to}
      data-testid={`market-card-${title.toLowerCase()}`}
      className="group relative flex flex-col rounded-xl border border-hair bg-white p-7 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-md hover:border-finblue/30"
    >
      <span className="absolute inset-x-0 top-0 h-0.5 scale-x-0 rounded-full bg-finblue transition-transform duration-300 group-hover:scale-x-100" />
      <span className="inline-flex h-12 w-12 items-center justify-center rounded-lg bg-navy text-gold">
        <Icon className="h-6 w-6" strokeWidth={1.5} />
      </span>
      <h3 className="mt-5 font-heading text-xl font-semibold text-ink">{title}</h3>
      <p className="mt-2 flex-1 text-sm leading-relaxed text-subtle">{description}</p>
      <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-finblue">
        {cta}
        <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
      </span>
    </Link>
  );
}
